import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetUserRequestsRequest = App.Http.Requests.UserRequest.GetUserRequestsRequest;
import GetUserRequestRequest = App.Http.Requests.UserRequest.GetUserRequestRequest;
import StoreUserRequestRequest = App.Http.Requests.UserRequest.StoreUserRequestRequest;
import UpdateUserRequestRequest = App.Http.Requests.UserRequest.UpdateUserRequestRequest;
import GetUserRequestsResponse = App.Http.Responses.UserRequest.GetUserRequestsResponse;
import GetUserRequestResponse = App.Http.Responses.UserRequest.GetUserRequestResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class RequestApi extends TenantBaseApi {
    /**
     * Get list of requests
     *
     * - Request: GetUserRequestsRequest
     * - Response: GetUserRequestsResponse
     */
    async index(request: GetUserRequestsRequest): Promise<GetUserRequestsResponse> {
        return await this.get<GetUserRequestsResponse, GetUserRequestsRequest>("/user-requests", {
            params: request,
        });
    }

    /**
     * Get a specific request by ID
     *
     * - Request: { id: string }
     * - Response: GetUserRequestResponse
     */
    async show(requestId: string, request: GetUserRequestRequest): Promise<GetUserRequestResponse> {
        return await this.get<GetUserRequestResponse, GetUserRequestRequest>(`/user-requests/${requestId}`, {
            params: request,
        });
    }

    /**
     * Store a new request
     *
     * - Request: StoreRequestRequest
     * - Response: GetUserRequestResponse
     */
    async store(request: StoreUserRequestRequest): Promise<GetUserRequestResponse> {
        return await this.post<GetUserRequestResponse, StoreUserRequestRequest>("/user-requests", request);
    }

    /**
     * Update a request by ID
     *
     * - Request: UpdateRequestRequest
     * - Response: GetUserRequestResponse
     */
    async update(requestId: string, request: UpdateUserRequestRequest): Promise<GetUserRequestResponse> {
        return await this.patch<GetUserRequestResponse, UpdateUserRequestRequest>(`/user-requests/${requestId}`, request);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/user-requests/export", request);
    }

    /**
     * Cancel a pending request (e.g. an admin cancelling a tenant invite before the
     * partner confirms it). Only pending requests can be cancelled.
     *
     * - Request: { id: string }
     * - Response: -
     */
    async destroy(requestId: string): Promise<null> {
        return await this.delete<null>(`/user-requests/${requestId}`);
    }
}

export const requestApi = new RequestApi();
